import appInfo from '../app.json';

export const VERSION = appInfo.expo.version;

export const PLAYSTORE_URL = appInfo.expo.android.playStoreUrl;

export const APP_NAME = 'RPG風画像ジェネレータ';
